import { render, staticRenderFns } from "./AssessmentTests.vue?vue&type=template&id=8763aabc&scoped=true&"
import script from "./AssessmentTests.vue?vue&type=script&lang=ts&"
export * from "./AssessmentTests.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentTests.vue?vue&type=style&index=0&id=8763aabc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8763aabc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VChip,VIcon,VImg})
